import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/bank-accounts/new/loading';

export const Route = createFileRoute('/_private/settings/bank-accounts/new')({
  component: Loading,
});
